import i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import ar from './locales/ar.json'
import de from './locales/de.json'
import en from './locales/en.json'
import es from './locales/es.json'
import fa from './locales/fa.json'
import fr from './locales/fr.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import ptPT from './locales/pt-PT.json'
import ru from './locales/ru.json'
import vi from './locales/vi.json'
import zhHant from './locales/zh-Hant.json'

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'English' },
  { code: 'zh-Hant', label: '繁體中文' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es', label: 'Español' },
  { code: 'fr', label: 'Français' },
  { code: 'ru', label: 'Русский' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'ar', label: 'العربية' },
  { code: 'fa', label: 'فارسی' },
  { code: 'pt-PT', label: 'Português' },
] as const

export const RTL_LANGUAGES = ['ar', 'fa']

const resources = {
  en: { translation: en },
  'zh-Hant': { translation: zhHant },
  ja: { translation: ja },
  ko: { translation: ko },
  de: { translation: de },
  es: { translation: es },
  fr: { translation: fr },
  ru: { translation: ru },
  vi: { translation: vi },
  ar: { translation: ar },
  fa: { translation: fa },
  'pt-PT': { translation: ptPT },
}

/** 已移除简体中文 `zh`：旧版 localStorage 仍存 zh 时改为 en，避免加载缺失 bundle */
function migrateLegacyZhLanguage(): void {
  try {
    const nextLng = 'en'
    const keys = ['i18nextLng', 'lang'] as const
    for (const k of keys) {
      const v = localStorage.getItem(k)
      if (v === 'zh' || v?.startsWith('zh-CN')) {
        localStorage.setItem(k, nextLng)
      }
    }
  } catch {
    /* ignore */
  }
}

migrateLegacyZhLanguage()

const supportedLngs = Object.keys(resources)

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs,
    debug: import.meta.env.DEV,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  })

function applyDirection(lng: string): void {
  const dir = RTL_LANGUAGES.includes(lng) ? 'rtl' : 'ltr'
  document.documentElement.setAttribute('dir', dir)
  document.documentElement.setAttribute('lang', lng)
}

applyDirection(i18n.language || 'en')
i18n.on('languageChanged', applyDirection)

export default i18n
